export const EMAIL_LABELS = {
	SECTION_TITLE: 'Email Notifications',
	SECTION_DESCRIPTION: 'Send emails automatically after a scheduled scan finishes.',
	SELECT_LABEL: 'Email recipients',
	SELECT_PLACEHOLDER: 'Select user',
	ADDED_RECIPIENTS_TITLE: 'Added recipients'
} as const;
